import React from 'react';
import { useMutation } from 'react-apollo';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { ADD_GROUP, UPDATE_ROOM_ID } from 'graphql/groups';
import useSnack from 'hooks/useSnack';
import GroupForm from './components/GroupForm';
import { CREATE_GROUP_ROOM } from 'graphql/chat';
import { useSelector } from 'react-redux';

const CreateGroup = ({ history }) => {
  const [addGroup] = useMutation(ADD_GROUP);
  const [createGroupRoom] = useMutation(CREATE_GROUP_ROOM);
  const [updateRoomID] = useMutation(UPDATE_ROOM_ID);
  const user = useSelector((s) => s.user.user);

  const snack = useSnack();

  const onSubmit = (values) => {
    return addGroup({
      variables: {
        data: {
          ...values,
          conversation: {
            data: {
              type: 'sms',
              users: {
                data: [
                  { user_id: values.hc_id },
                  { user_id: values.lc_id },
                  { user_id: user.id },
                ],
              },
              subject: values.name,
            },
          },
        },
      },
    }).then(
      ({ data }) => {
        const group = data.row;

        createGroupRoom({
          variables: {
            lcId: group.lc_id,
            hcId: group.hc_id,
            userId: user.id
          },
        }).then(({ data }) =>
          updateRoomID({
            variables: {
              id: group.id,
              data: { room_id: data.insert_chat_rooms.returning[0].id },
            },
          }),
        );
        snack.success('Group created');
        history.push('/groups');
      },
      (e) => {
        snack.error(e.message);
      },
    );
  };

  return (
    <Box>
      <Typography gutterBottom variant="h6" color="textPrimary">
        Create Group
      </Typography>
      <br />
      <Grid container>
        <Grid item md={6} lg={4}>
          <GroupForm onSubmit={onSubmit} onCancel={() => history.goBack()} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreateGroup;
